import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { debounce } from 'lodash';
import { FORMS_TYPES } from 'common/types';
import CustomTextField from 'components/CustomTextField';
import { useFormValidation } from 'services/hooks/useFormValidation';
import { FormValueProFormaCapTable, ProformaCapTableFormProps } from './ProformaCapTableForm.props';

const constraints = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
    length: { minimum: 3, message: 'must be at least 3 characters' },
  },
};

const ProformaCapTableForm = ({ initialValues, onFormChange, tableTerms }: ProformaCapTableFormProps) => {
  const { formValidated, validateForm } = useFormValidation(constraints);
  const [formValues, setFormValues] = useState<FormValueProFormaCapTable>(initialValues);
  const { errors } = formValidated;

  useEffect(() => {
    validateForm(formValues);
  }, [validateForm, formValues]);

  const onInputChange = debounce(() => {
    onFormChange(formValidated);
  }, 1000);

  useEffect(() => {
    onInputChange();
  }, [onInputChange, onFormChange, formValidated]);

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  return (
    <Grid container>
      <CustomTextField
        required
        fullWidth
        id="name"
        name="name"
        type="text"
        label={`${tableTerms.tableName} name`}
        value={(formValues.name as string) ?? ''}
        onChange={handleChange}
        formErrors={errors as FORMS_TYPES.FormFieldErrors}
      />
    </Grid>
  );
};

export default ProformaCapTableForm;
